import React from 'react';

interface TranslationTabsProps {
  activeTab: 'texts' | 'quickActions' | 'miniApps';
  onTabChange: (tab: 'texts' | 'quickActions' | 'miniApps') => void;
}

export function TranslationTabs({ activeTab, onTabChange }: TranslationTabsProps) {
  return (
    <div className="flex border-b border-white/10 flex-wrap">
      <button
        onClick={() => onTabChange('texts')}
        className={`px-6 py-3 text-sm font-medium transition-colors ${
          activeTab === 'texts'
            ? 'text-white border-b-2 border-indigo-500'
            : 'text-gray-400 hover:text-white'
        }`}
      >
        Basic texts
      </button>
      <button
        onClick={() => onTabChange('quickActions')}
        className={`px-6 py-3 text-sm font-medium transition-colors ${
          activeTab === 'quickActions'
            ? 'text-white border-b-2 border-indigo-500'
            : 'text-gray-400 hover:text-white'
        }`}
      >
        Quick actions
      </button>
      <button
        onClick={() => onTabChange('miniApps')}
        className={`px-6 py-3 text-sm font-medium transition-colors ${
          activeTab === 'miniApps'
            ? 'text-white border-b-2 border-indigo-500'
            : 'text-gray-400 hover:text-white'
        }`}
      >
        Mini Apps
      </button>
    </div>
  );
}